import React, { useRef } from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { axiosInstance } from '../../Helpers/axiosInstance'
import DatePicker from 'react-datepicker'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faPenToSquare, faPlus, faTrash, faUpload } from '@fortawesome/free-solid-svg-icons'
import AccidentPeople from './AccidentPeople'
import FileUpload from '../../Components/FileUploader'
import { BACKEND_URL } from '../../Helpers/constants'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function AccidentUnitModal({closeModal, unitList, fetchInfo, item }) {
    const [unit, setUnit] = useState("")
    const [date, setDate] = useState(getDate(new Date()))
    const [time, setTime] = useState(null)

    const [accidentDescription, setAccidentDescription] = useState("")
    const [files, setFiles] = useState(null)
    const [carModel, setCarModel] = useState("")
    const [carNum, setCarNum] = useState("")
    const [carOwner, setCarOwner] = useState("")
    const [addingModal, setAddingModal] = useState(false)
    const [hurtedPeople, setHurtedPeople] = useState([])
    const [editing, setEditing] = useState(null)
    const [editingIndex, setEditingIndex] = useState(null)
    const [deletedFiles, setDeletedFiles] = useState([])

    const nodeRef = useRef(null);

    const imageExt = ['jpg','jpeg','png','gif','webp','bmp','tiff','svg','ico','heic','heif'];
    const videoExt = ['mp4','webm','ogg','mov','avi','wmv','mpeg','3gp','3gpp'];

    useEffect(() => {
        if (item) {
            setUnit(item.mil_unit);
            setDate(getDate(new Date(item.date)));
            setTime(new Date(item.date).getHours().toString().padStart(2, '0') + ":" + new Date(item.date).getMinutes().toString().padStart(2, '0'));
            setAccidentDescription(item.accident_description);
            setCarModel(item.car_model);
            setCarNum(item.car_num);
            setCarOwner(item.car_owner);
            setHurtedPeople(item.hurted_people);
            setFiles(item.files || []);
        }
    }, [item]);

    function getDate(date) {
        const parts = new Intl.DateTimeFormat("en-GB").formatToParts(date);
        const day = parts.find((p) => p.type === "day").value;
        const month = parts.find((p) => p.type === "month").value;
        const year = parts.find((p) => p.type === "year").value;
        const formatted = `${day}/${month}/${year}`;
        return formatted;
    }

    function unGetDate(date) {
        if (date) {
        const [day, month, year] = date.split("/");
        const formatted = `${month}/${day}/${year}`;
        return formatted;
        }
    }

    function addHurtedPeople(person) {
        setHurtedPeople([...hurtedPeople, person])
    }

    function editHurtedPeople(person) {
        setHurtedPeople(p => {p[editingIndex] = person; return p})
    }

    function deleteHurtedPeople(item){
        setHurtedPeople(p => p.filter(el => el.person._id != item.person._id ))
    }

    function closeAddingModal() {
        setAddingModal(false)
        setEditing(null)
        setEditingIndex(null)
    }

    async function add(){
        if(!unit){
            toast.error("Զորամասը պարտադիր է");
            return;
        }
        const res = await axiosInstance.post("/admin/unit-accident", {
            mil_unit: unit,
            files,
            date: new Date(unGetDate(date) + " " + time),
            accident_description: accidentDescription,
            car_model: carModel,
            car_num: carNum,
            car_owner: carOwner,
            hurted_people: hurtedPeople
        })
        if(res.data?.status){
            if(deletedFiles.length){
                for(const file of deletedFiles){
                    axiosInstance.delete("/admin/delete-file/" + file.split("uploads/").pop());
                }
            }
            closeModal()
        }
    }

    async function edit(){
        if(!unit){
            toast.error("Զորամասը պարտադիր է");
            return;
        }
        const res = await axiosInstance.put("/admin/unit-accident/" + item._id, {
            mil_unit: unit,
            files,
            date: new Date(unGetDate(date) + " " + time),
            accident_description: accidentDescription,
            car_model: carModel,
            car_num: carNum,
            car_owner: carOwner,
            hurted_people: hurtedPeople
        })
        if(res.data?.status){
            if(deletedFiles.length){
                for(const file of deletedFiles){
                    axiosInstance.delete("/admin/delete-file/" + file.split("uploads/").pop());
                }
            }
            closeModal()
            fetchInfo()
        }
    }

    const removeFile = async (index) => {
        setDeletedFiles((prev) => [...prev, files[index]]);
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    }

  return (
        <div className='fixed w-screen h-screen bg-black/40 top-0 left-0 flex justify-center items-center z-10'>
            <div ref={nodeRef} className='max-w-[90%] max-h-[90%] bg-white rounded-lg p-4 overflow-x-auto' onClick={e => e.stopPropagation()}>
                <h2 className='text-center mb-4'>Մուտքագրել պատահարի մասին տեղեկատվությունը</h2>
                <div className="relative w-1/2 mx-auto mb-4">
                    <label htmlFor="unit" className='absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap'>Զորամաս</label>
                    <select id="unit" className="w-full border border-gray-500 rounded-md p-2 disabled:bg-gray-200" value={unit} onChange={(e) => setUnit(e.target.value)}>
                        <option value=""></option>
                        {unitList?.map((item, index) => (
                            <option key={index} value={item._id}>{item.unit_number}</option>
                        ))}
                    </select>
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <div className="relative">
                        <label htmlFor="date" className='absolute z-10 top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap'>Ամսաթիվ</label>
                        <DatePicker
                            selected={date ? unGetDate(date) : null}
                            onChange={(date) => setDate(getDate(date))}
                            locale="hy"
                            dateFormat="dd MMMM yyyy"
                            id="date"
                            className="border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200"
                        />
                    </div>
                    <div className='relative '>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="time">Ժամ</label>
                        <input type="time" id="time" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={time} onChange={e => setTime(e.target.value)} />
                    </div>
                </div>
                <div className='relative mb-2 mt-4'>
                    <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="acciden_description">Պատահարի նկարագիրը</label>
                    <textarea id="acciden_description" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={accidentDescription} onChange={e => setAccidentDescription(e.target.value)}/>
                </div>
                <div className='w-1/2 mx-auto mb-4'>
                    <FileUpload setImage={setFiles} many={true} images={files}/>
                </div>
                {files?.length > 0 && <div className='grid grid-cols-10 gap-4 items-center my-2'>
                    {files.map((file, index) => imageExt.includes(file.split(".").pop().toLowerCase()) ? (
                        <div className='relative group'>
                            <img key={index} src={BACKEND_URL + file} alt={`Uploaded file ${index}`} className='w-full h-auto' />
                            <div className='w-full h-full absolute top-0 left-0 bg-black/20 flex justify-center items-center opacity-0 group-hover:opacity-100'>
                                <FontAwesomeIcon icon={faTrash} className="text-red-500 bg-white rounded-full p-1 opacity-0 group-hover:opacity-100 cursor-pointer" title="Հեռացնել ֆայլը" onClick={() => removeFile(index)}/>
                            </div>
                        </div>
                    ) : videoExt.includes(file.split(".").pop().toLowerCase()) ? (
                            <div className='relative group'>
                                <video key={index} src={BACKEND_URL + file} controls className='w-full h-auto' />

                            <div className='w-full h-full absolute top-0 left-0 bg-black/20 flex justify-center items-center opacity-0 group-hover:opacity-100'>
                                <FontAwesomeIcon icon={faTrash} className="text-red-500 bg-white rounded-full p-1 opacity-0 group-hover:opacity-100 cursor-pointer" title="Հեռացնել ֆայլը" onClick={() => removeFile(index)}/>
                            </div>
                        </div>
                    ) : null)}
                </div>}
                <div className='border border-gray-500 rounded-md p-2 mb-4'>
                    <p className='text-center mb-4'>Ավտովթարի դեպքում <FontAwesomeIcon icon={faArrowDown} /></p>
                    <div className='grid grid-cols-3 gap-4'>
                        <div className='relative '>
                            <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="car_model">Մեքենայի մակնիշ</label>
                            <input type="text" id="car_model" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={carModel} onChange={e => setCarModel(e.target.value)} />
                        </div>
                        <div className='relative '>
                            <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="car_num">Մեքենայի համարանիշ</label>
                            <input type="text" id="car_num" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={carNum} onChange={e => setCarNum(e.target.value)} />
                        </div>
                        <div className='relative '>
                            <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="car_owner">Պատկանելություն</label>
                            <input type="text" id="car_owner" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={carOwner} onChange={e => setCarOwner(e.target.value)} />
                        </div>                    
                    </div>
                </div>
                <div className='relative border-b border-b-gray-500'>
                    <h2 className='text-center'>Տուժած զինծառայողներ</h2>
                    <FontAwesomeIcon icon={faPlus} className="absolute top-0 right-4 cursor-pointer border border-gray-500 rounded-md p-2" title="Ավելացնել տվյալներ" onClick={() => setAddingModal((true))}/>
                </div>
                <div>
                    {hurtedPeople.length ? hurtedPeople.map((el, i) => (
                        <div key={el.person?._id} className='grid grid-cols-5 gap-2 w-full p-2'>
                            <div >{el.person?.full_name}</div>
                            <div className='text-center'>{el.responsibility}</div>
                            <div className='text-center'>{el.result === "hurt" ? "Վիրավորվել է" : el.result === "victim" ? "Զոհվել է" : ""}</div>
                            <div className='text-center'>{el.hospital}</div>
                            <button className="flex items-center justify-end">
                                <FontAwesomeIcon icon={faPenToSquare} title="Փոփոխել" className="mr-4 cursor-pointer" onClick={() => {setEditingIndex(i); setEditing(el); setAddingModal(true)}}/>
                                <FontAwesomeIcon icon={faTrash} title="Հեռացնել" className="cursor-pointer" onClick={() => deleteHurtedPeople(el)}/>
                            </button>
                        </div>
                    )) : ""}
                </div>
                {addingModal && <AccidentPeople editHurtedPeople={editHurtedPeople} editing={editing} currentUnit={{_id: unit}} getDate={getDate} unGetDate={unGetDate} addHurtedPeople={addHurtedPeople} onClose={closeAddingModal}/>}

                {/* <div className='grid grid-cols-2 gap-4'>
                    <div className='relative '>
                        <label className="absolute top-[-0.5rem] bg-gradient-to-t from-gray-200 to-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="rang">Զինկոչում</label>
                        <input type="text" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' disabled value={rang + " " + (type&& type === "haveTo" ? "" : "Պ")} />
                    </div>
                    <div className='relative '>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="birthday">Ծննդյան տարեթիվ</label>
                        <input type="date" id="birthday" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' disabled value={birthday}/>
                    </div>
                    <div className='relative'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] bg-gradient-to-t from-gray-200 to-white" htmlFor="position">Պաշտոն</label>
                        <input className='w-full border border-gray-500 rounded-md p-2 disabled:bg-gray-200' id="position" type="text" value={position} disabled />
                    </div>
                    <div className='relative'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] bg-gradient-to-t from-gray-200 to-white" htmlFor="battalion">Գումարտակ</label>
                        <input className='w-full border border-gray-500 rounded-md p-2 disabled:bg-gray-200' id="battalion" type="text" value={battalion + " " + company + " " + platoon} disabled />
                    </div>
                    <div className='relative '>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="conscription">Զորակոչ</label>
                        <input type="text" id="conscription" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={conscription} disabled/>
                    </div>
                    <div className='relative'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="milCommissariat">Զինկոմիսարիատ</label>
                        <input type="text" id="milCommissariat" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={milCommissariat} disabled />
                    </div>
                    <div className='relative'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="address">Հասցե</label>
                        <input type="text" id="address" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={address} disabled />
                    </div>
                </div> */}
                <div className='grid grid-cols-2 gap-4 justify-center items-center '>
                    <button className='mt-4 bg-blue-500 text-white px-4 py-2 rounded-md' onClick={item ? edit : add}>Պահպանել</button>
                    <button className='mt-4 bg-gray-300 text-white px-4 py-2 rounded-md ' onClick={closeModal}>Փակել</button>
                </div>
                <ToastContainer position="top-right" autoClose={3000} />
            </div>
    </div>
  )
}
